module.exports = __webpack_public_path__ + "static/media/sf_1800_gray.6e1b03432a77835cac092b2d0e104ac7.png";